import { render, staticRenderFns } from "./crm-report.vue?vue&type=template&id=a8680794"
import script from "./crm-report.vue?vue&type=script&lang=js"
export * from "./crm-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports